import { useState } from 'react';
import styles from './CommonHeader.module.scss';
import { MenuModal } from '~/components';
import { Link } from 'react-router-dom';
import VietnamMap from '~/assets/images/vietnam.png';
import { checkAuthen } from '~/helpers/authen';
import { useStore } from '~/store';

function CommonHeader({ title, hidden }) {
    const [state] = useStore();
    const { tripName } = state;
    const [showMenuModal, setShowMenuModal] = useState(false);

    const handleOnClickMenu = () => {
        setShowMenuModal((pre) => !pre);
    };

    return (
        <>
            <div className={styles.sticky}>
                <header className={styles.header}>
                    <div className={styles.menu} onClick={handleOnClickMenu}>
                        <i className="fa-solid fa-bars"></i>
                    </div>
                    <div className={styles.mainTitle}>{title}</div>
                    <Link to={`/money`} className={styles.home}>
                        <img src={VietnamMap} alt="Vietnam map" />
                    </Link>
                </header>
            </div>
            {!hidden && checkAuthen() && tripName && (
                <footer className={styles.footer}>
                    <i className="fa-solid fa-car-side"></i>
                    <span>{tripName}</span>
                    <i className="fa-solid fa-car-side"></i>
                </footer>
            )}
            {showMenuModal && (
                <div className={styles.menuModal}>
                    <MenuModal onClickOutside={() => setShowMenuModal(false)} />
                </div>
            )}
        </>
    );
}

export default CommonHeader;
